import React from 'react';
import PropTypes from 'prop-types';

// -156 is a row rythm for the tool icons based on the sprite image distribution
const ROWRYTHM = -156;

const MyAppCardItemIcon = props => {
  const { app, user, hasFavorite } = props;

  const calculatePosition = () => {
    const iconMultipler = {
      pp_third_party_shopping_card: 0,
      pp_tax_calculator: 1,
      pp_promote_financing: 2,
      pp_website_payments_pro: 3,
      pp_paypal_plus: 3,
      pp_hosted_sole_solution: 4,
      pp_express_checkout: 5,
      pp_manage_billing: 6,
      pp_invoicing: 7,
      pp_api_access: 8,
      pp_express_invoice: 9,
      pp_multi_order_shipping: 9.95,
      pp_business_resource_center: 11,
      pp_buttons: 12,
      pp_pos: 13,
      pp_manage_fraud_filters: 13.95,
      pp_recurring_payments: 15,
      pp_virtual_terminal: 16,
      pp_bpi_optimizer: 17,
      pp_here:
        user && (user.legalCountry === 'GB' || user.legalCountry === 'AU')
          ? 33
          : 18,
      pp_cross_border_trade: 19,
      pp_logo_center: 20,
      pp_request_money: 31,
      pp_resolution_center: 22,
      pp_currency_calculator: 23,
      pp_dev_site: 24,
      pp_quickBook: 25,
      pp_working_capital: 26,
      pp_debitcard: 27,
      pp_masspay: 28,
      pp_self_service_demand_gen: 29,
      pp_shipping_calculator: 29.95,
      pp_send_money: 21,
      pp_installments: 32,
      pp_business_setup: 34,
      pp_ppgf: 35,
      pp_tag_manager: 35,
      pp_payflow_fraud_filters: 14,
      pp_smart_incentives: 36,
      pp_shopper_insights: 37,
      pp_gift_aid: 38,
      pp_raas: 39,
      pp_store_cash: 37,
      pp_subscriptions_v1: 15
    };

    return iconMultipler[app] * ROWRYTHM;
  };

  return (
    <div
      className={`${hasFavorite ? `${app}-card ` : ''}myapps-card-icon`}
      style={{ backgroundPosition: `0 ${calculatePosition()}px` }}
    />
  );
};

MyAppCardItemIcon.propTypes = {
  app: PropTypes.string,
  user: PropTypes.object,
  hasFavorite: PropTypes.bool
};

export default MyAppCardItemIcon;
